export const PERMISSIONS = {
    ADMINISTRATION: "Administration",
    IMPERSONATION: "Impersonation",
    IMPERSONATION_PROJECTS: "ImpersonationProjects",
    GLOBAL_ADMINISTRATION: "GlobalAdministration",
    GLOBAL_REPORTS: "GlobalReports",
    GLOBAL_USER_MANAGEMENT: "GlobalUserManagement",
    REPORTS: "Reports",
    LOCKING: "Locking",
    USER_MANAGEMENT: "UserManagement",
};
